import { createNameComponent } from '../createNode'
import Page from "@/layout/index.vue";
const route = [
  {
    path: '/404',
    component: createNameComponent(() => import('@/views/main/404.vue')),
    hideMenu: true,
    meta: { title: '404' }
  },
  {
    path: '/401',
    hideMenu: true,
    component: createNameComponent(() => import('@/views/main/401.vue')),
    meta: { title: '401' }
  },
  {
    path: '/login',
    hideMenu: true,
    component: createNameComponent(() => import('@/views/main/login.vue')),
    meta: { title: '登录'}
  },
  {
    path: '/redirect/:path(.*)',
    hideMenu: true,
    component: createNameComponent(() => import('@/views/main/redirect.vue')),
    meta: { title: '重定向页面' }
  },
  {
    path: '/',
    hideMenu: true,
    redirect: '/user'
  },
  {
    path: '/system',
    name: 'System',
    meta: { title: '系统管理' },
    component: Page,
    children: [
      // 页面路由
      {
        path: '/user',
        name: 'UserIndex',
        component: () => import('@/views/system/user/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: '/log',
        name: 'SystemLog',
        component: () => import('@/views/system/systemLog/index.vue'),
        meta: { title: '操作日志' }
      },
      // 操作项（无组件）
      {
        path: 'change-name',
        name: 'ChangeSystemName',
        meta: {
          title: '修改系统名称',
          isAction: true // 标记为操作项
        }
      },
      {
        path: '/records',
        name: 'records',
        component: () => import('@/views/system/records/index.vue'),
        meta: { title: '咨询记录' }
      },
      {
        path: '/website',
        name: 'website',
        component: () => import('@/views/system/website/index.vue'),
        meta: { title: '网站模块管理' }
      },
    ]
  },
  {
    path: '/home',
    name: 'Home',
    meta: { title: '网站首页' },
    component: Page,
    children: [
      // 页面路由
      {
        path: '/banner',
        name: 'BannerIndex',
        component: () => import('@/views/website/activity/index.vue'),
        meta: { title: 'banner' }
      },
      {
        path: '/consulting',
        name: 'Consulting',
        component: () => import('@/views/website/consulting/index.vue'),
        meta: { title: '全案咨询' }
      },
      {
        path: '/team',
        name: 'Team',
        component: () => import('@/views/website/team/index.vue'),
        meta: { title: '团队信息' }
      },
      {
        path: '/userCase',
        name: 'UserCase',
        component: () => import('@/views/website/userCase/index.vue'),
        meta: { title: '客户案例' }
      },
    ]
  },
  {
    path: '/news',
    name: 'News',
    meta: { title: '新闻管理' },
    component: Page,
    children: [
      // 页面路由
      {
        path: '/dynamics',
        name: 'DynamicsIndex',
        component: () => import('@/views/news/dynamics/index.vue'),
        meta: { title: '新闻动态' }
      },
      {
        path: '/service',
        name: 'Service',
        component: () => import('@/views/news/service/index.vue'),
        meta: { title: '服务案例' }
      }
    ]
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    meta: { title: '企业信息' },
    component: Page,
    children: [
      // 页面路由
      {
        path: '/about',
        name: 'AboutIndex',
        component: () => import('@/views/enterprise/about/index.vue'),
        meta: { title: '关于我们' }
      },
      {
        path: '/contact',
        name: 'ContactIndex',
        component: () => import('@/views/enterprise/contact/index.vue'),
        meta: { title: '联系我们' }
      },
      {
        path: '/hire',
        name: 'HireIndex',
        component: () => import('@/views/enterprise/hire/index.vue'),
        meta: { title: '招聘信息' }
      },
      {
        path: '/product',
        name: 'ProductIndex',
        component: () => import('@/views/enterprise/product/index.vue'),
        meta: { title: '公司产品' }
      },
    ]
  },
]

export default route
